import mixpanel from 'mixpanel-browser'

// SC-11888: uso dos atalhos da topbar (os atalhos de página ao lado do Buscar e o
// "+" de criar). Um evento só para os dois tipos (`tipo`), para comparar o uso
// num relatório; abrir/editar/concluir têm eventos próprios.
export const TOPBAR_EVENTS = {
  used: 'Atalho da topbar usado',
  createOpened: 'Menu Criar aberto',
  createCompleted: 'Criar pela topbar concluído',
  shortcutsEdited: 'Atalhos da topbar editados'
} as const

type TopbarEvent = (typeof TOPBAR_EVENTS)[keyof typeof TOPBAR_EVENTS]

// Só envia com o Mixpanel carregado (fora de produção ele não é inicializado).
export const trackTopbar = (
  event: TopbarEvent,
  properties?: Record<string, unknown>
) => {
  const loaded = (mixpanel as unknown as { __loaded?: boolean }).__loaded
  if (!loaded) return
  mixpanel.track(event, properties)
}
